import { UseGetResponsesApiFilters } from "../../api/methods/use-get-responses-api";
import React from "react";
import { useSearchParams } from "react-router-dom";

export const useGetResponsesApiFilters = (): UseGetResponsesApiFilters => {
  const [searchParams] = useSearchParams();

  const filters: UseGetResponsesApiFilters = React.useMemo(() => {
    return {
      skipped: searchParams.get("skipped")
        ? searchParams.get("skipped") === "true"
        : undefined,
      guesses: searchParams.get("guesses")
        ? searchParams.get("guesses") === "true"
        : undefined,
      processed: searchParams.get("processed")
        ? searchParams.get("processed") === "true"
        : undefined,
      retags: searchParams.get("retags")
        ? searchParams.get("retags") === "true"
        : undefined,
    };
  }, [searchParams]);

  return filters;
};
